import request from "./tsa.js";
import qs from 'qs'

//案例栏目列表
export const dictionary = type =>
    request({
        url: `/dictionary/search?type=${type}`,
        method: "get"
    });

//栏目对应案例
export const precedent = params =>
    request({
        url: `/precedent/search`,
        method: "get",
        params
    });

//常见问题
export const questionAnswer = params =>
    request({
        url: `/questionAnswer/search`,
        method: "get",
        params
    });

// 判例数
export const precedentStatistics = params =>
    request({
        url: `/precedentStatistics/searchOne`,
        method: "get"
    });

//获取时间戳
export const getCurrentTime = params =>
    request({
        url: `/time/getCurrentTime`,
        method: "get"
    });

//开放申请信息
export const sendDingDing = data =>
    request({
        headers: {
            "content-type": "application/json;charset=UTF-8"
        },
        url: `/sendTools`,
        method: "post",
        data
    });

//获取验证码
export const sendSmsCode = data =>
    request({
        url: `/captcha/sendSmsCode`,
        method: "post",
        data: qs.stringify(data)
    });